import React from 'react'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import { Row, Container } from 'react-bootstrap'
import { AccordionBlockPDP } from 'src/views/components/AccordionBlockPDP'
import { ImageComponent } from 'src/views/components/ImageComponent'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import Modal from 'react-bootstrap/Modal'
import { enablePdpRedesign, getProductPDPTitle } from 'src/utils/commonUtils'
import { observable } from 'mobx'
import { APPConfig } from 'config/appConfig'
import './styles.scss'

@observer
class ProductIngredients extends React.Component {
  nameSpace = 'ssr-resource'
  @observable modalShow = false
  @observable nutritionInformationImage = {}

  renderTitle = () => {
    const { isAccordionType = false } = this.props
    const ingredientsLable = getProductPDPTitle(
      this.props.product?.tempProperties,
      'ingredients'
    )
    return (
      <Row
        as="h3"
        className={`about-title ${
          isAccordionType ? 'text-uppercase' : 'border-light-grey'
        }  ${enablePdpRedesign() ? 'pdp-redesign-title' : ''}`}
        noGutters>
        {ingredientsLable ||
          i18nTranslate('pdp.ingredients', 'Ingredients', {
            nameSpace: this.nameSpace,
          })}
      </Row>
    )
  }

  handleShow = nutritionInformationImage => {
    this.nutritionInformationImage = nutritionInformationImage
    this.modalShow = true
  }

  handleClose = () => {
    this.nutritionInformationImage = {}
    this.modalShow = false
  }
  enableNewPDPStyle = APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'

  renderKeyIngredients = keyIngredients => {
    return (
      <>
        <h4 className="subhead-m">
          {i18nTranslate('key_ingredients', 'Key ingredients')}
        </h4>
        <div className="d-flex flex-wrap align-items-center keyingredian-main">
          {keyIngredients?.length > 0 &&
            keyIngredients?.map((ingredientsdet, idx) => {
              return (
                <div
                  className={`key-ingredients-inner d-flex flex-row align-items-center ${
                    this.enableNewPDPStyle ? '' : 'mb-4'
                  } ${enablePdpRedesign() ? 'pdp-redesign-desc-text mb-0' : ''}`}
                  key={idx}>
                  {ingredientsdet?.image?.url && (
                    <div className="mr-2">
                      <img
                        src={ingredientsdet?.image?.url || imagePlaceholder}
                        alt=""
                        aria-hidden="true"
                        className="keyimage"
                        onError={e => {
                          if (e.target.src != imagePlaceholder) {
                            e.target.onerror = null
                            e.target.src = imagePlaceholder
                          }
                        }}
                      />
                    </div>
                  )}
                  <div>
                    <h4 className="heading-5">
                      {ingredientsdet['name'] || ''}
                    </h4>
                    <p className="paragraph-m my-0">
                      {ingredientsdet['description'] || ''}
                    </p>
                  </div>
                </div>
              )
            })}
        </div>
      </>
    )
  }

  renderContent = () => {
    let ingredients = []
    let showIngredients = false
    const product = this.props?.product || {}
    try {
      ingredients = JSON.parse(product?.ingredients || '[]')
    } catch (e) {
      console.log('ingredient data parsing error ' + e)
    }
    return ingredients.map(ingredient => {
      const {
        activeIngredients = '',
        inactiveIngredients = '',
        allIngredients = '',
        keyIngredients = [],
        nutritionInformationImage = '',
        nutritionFacts = '',
        otherIngredients = '',
        ingredientDisclaimers = '',
        productName = '',
      } = ingredient || {}
      if (
        activeIngredients != '' ||
        allIngredients != '' ||
        inactiveIngredients != '' ||
        ingredientDisclaimers?.length > 0 ||
        keyIngredients?.length > 0 ||
        (nutritionInformationImage != null &&
          nutritionInformationImage != '') ||
        otherIngredients != '' ||
        (nutritionFacts != '' && nutritionFacts != undefined)
      ) {
        showIngredients = true
      }
      const infoClassName = !this.enableNewPDPStyle
        ? 'v2-all-ingredient-info my-0'
        : 'all-ingredient-info paragraph-m my-0'

      return (
        <Container className="pdp-accordion-content-container ingredient-wrapper">
          <div
            className="key-ingredients-accordion pr-0 pr-md-4"
            data-testid="qa-pdp-all-ingredients">
            {productName && (
              <div className="key-ingredients-productname">{productName}</div>
            )}
            {keyIngredients?.length > 0 &&
              !this.enableNewPDPStyle &&
              this.renderKeyIngredients(keyIngredients)}

            {keyIngredients?.length > 0 && this.enableNewPDPStyle && (
              <div className="mt-2">
                {this.renderKeyIngredients(keyIngredients)}
              </div>
            )}

            {allIngredients && (
              <div
                className={`all-ingredient ${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''}`}>
                <h4 className="heading-5 pb-2">
                  {i18nTranslate('all_ingredients', 'All Ingredients')}
                </h4>
                <p className={infoClassName}>{allIngredients}</p>
              </div>
            )}
            {activeIngredients && (
              <div
                className={`all-ingredient mt-2${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''} `}>
                <h4 className="heading-5 pb-2">{i18nTranslate('active_ingredients', 'Active Ingredients', { nameSpace: 'ssr-resource' })}</h4>
                <p className={infoClassName}>{activeIngredients}</p>
              </div>
            )}
            {inactiveIngredients && (
              <div
                className={`all-ingredient mt-2${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''} `}>
                <h4 className="heading-5 pb-2">{i18nTranslate('inactive_ingredients', 'Inactive Ingredients', { nameSpace: 'ssr-resource' })}</h4>
                <p className={infoClassName}>{inactiveIngredients}</p>
              </div>
            )}
            {(nutritionInformationImage || otherIngredients) && (
              <div className="other-ingredient mt-2 d-flex flex-lg-row flex-sm-column flex-xs-column">
                {nutritionInformationImage &&
                  nutritionInformationImage != null && (
                    <div
                      onClick={() => this.handleShow(nutritionInformationImage)}
                      className="Otheringredient-img-wrapper mt-2 col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0">
                      <div className="Otheringredient-img">
                        <ImageComponent
                          src={nutritionInformationImage?.url}
                          alt={nutritionInformationImage?.alt || ''}
                          // height={'400px'}
                          // width={'400px'}
                          backgroundColor={false}
                          scrSet={[200, 300, 1500]}
                        />
                      </div>
                    </div>
                  )}
                {otherIngredients && otherIngredients?.length > 0 && (
                  <div className="mt-2 col-lg-6 col-md-12 col-sm-12 col-xs-12 ingredients-ipad-padding">
                    <div
                      className={`all-ingredient mt-2${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''} `}>
                      <h4 className="heading-5 pb-2">{i18nTranslate('other_ingredients', 'Other Ingredients', { nameSpace: 'ssr-resource' })}</h4>
                      <p className={infoClassName}>{otherIngredients}</p>
                    </div>
                  </div>
                )}
              </div>
            )}
            {ingredientDisclaimers?.length > 0 && (
              <div
                className={`ingredient-disclaimer mt-4 ${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''} `}>
                {ingredientDisclaimers.map((ingredient, idx) => (
                  <p key={idx} className="ingredient-disclaimer-content mb-0">
                    {ingredient}
                  </p>
                ))}
              </div>
            )}
            <div></div>
          </div>
        </Container>
      )
    })
  }

  render() {
    let ingredients = []
    let showIngredients = false
    const product = this.props?.product || {}
    try {
      ingredients = JSON.parse(product?.ingredients || '[]')
    } catch (e) {
      console.log('ingredient data parsing error ' + e)
    }
    const {
      activeIngredients = '',
      inactiveIngredients = '',
      allIngredients = '',
      keyIngredients = [],
      nutritionInformationImage = '',
      nutritionFacts = '',
      otherIngredients = '',
    } = ingredients[0] || {}
    if (
      (activeIngredients !== '' && activeIngredients !== null) ||
      (allIngredients !== '' && allIngredients !== null) ||
      (inactiveIngredients !== '' && inactiveIngredients !== null) ||
      keyIngredients?.length > 0 ||
      (nutritionInformationImage !== null &&
        nutritionInformationImage !== '') ||
      (otherIngredients !== '' && otherIngredients !== null) ||
      (nutritionFacts !== '' && nutritionFacts !== undefined)
    ) {
      showIngredients = true
    }
    return (
      <>
        {showIngredients && (
          <div
            className={`${enablePdpRedesign() ? 'product-accordion-wrapper-pdp' : ''} product-accordion-wrapper`}
            id="ingredients">
            <AccordionBlockPDP
              title={this.renderTitle()}
              isDefaultOpen={false}
              className="accordion-description"
              dataTestId="qa-pdp-product-ingredients">
              {this.renderContent()}
            </AccordionBlockPDP>
          </div>
        )}
        <Modal
          className="modal-max-width pl-0"
          show={this.modalShow}
          onHide={this.handleClose}
          centered>
          <Modal.Header
            className="border-bottom-0 px-4 pb-0"
            closeButton></Modal.Header>
          <Modal.Body className="border-bottom-0 px-4 pt-4">
            <ImageComponent
              src={this.nutritionInformationImage?.url}
              alt={this.nutritionInformationImage?.alt || ''}
              // height={'400px'}
              // width={'400px'}
              scrSet={[200, 300, 1500]}
            />
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export { ProductIngredients }
